<script setup lang="ts">
import { CoreEventSource } from '@apps/main/new-desktop/core/models';

import { isFeatureToggleActive } from '@libs/feature-toggle';

import { useTripOverviewPageStore } from '../../stores';
import TripOverviewHeader from '../tripOverviewHeader/TripOverviewHeader.vue';
import FirstDayTripPriceRibbon from '../../../../core/components/FirstDayTripPriceRibbon.vue';
import { TripOverviewTemplateIds } from '../../models';

import TripItinerary from './TripItinerary.vue';
import TripItineraryLoader from './loaders/TripItineraryLoader.vue';

const tripOverviewPageStore = useTripOverviewPageStore();
</script>

<template>
  <div class="trip-overview-column">
    <div class="trip-overview-column-header">
      <TripOverviewHeader />
      <div class="price-ribbon-wrapper">
        <FirstDayTripPriceRibbon
          :id="TripOverviewTemplateIds.PriceCalendar"
          :show-month-select-dropdown="false"
          :source="CoreEventSource.TripOverview"
          scroll-track-theme="white"
        />
      </div>
    </div>

    <TripItinerary
      v-if="
        tripOverviewPageStore.anyItineraryLoaded &&
        !isFeatureToggleActive('loader')
      "
      :print-mode="false"
    />
    <TripItineraryLoader v-else />
  </div>
</template>

<style scoped lang="scss">
.trip-overview-column {
  border-radius: var(--border-radius-12);
  background-color: var(--color-off-white);
  .trip-overview-column-header {
    background-color: var(--color-white);
    .price-ribbon-wrapper {
      padding: 0 var(--spacing-24);
      background-color: var(--color-white);

      @include for-less-or-equal-than-599-px {
        padding: 0;
      }
    }

    .global-suggestion {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }

  @include for-less-or-equal-than-899-px {
    border-radius: 0;
  }
}
</style>
